import { Component, OnInit } from '@angular/core';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { Pregunta } from '../../_models/pregunta';
import { BancoPreguntasService } from '../../_services/banco-preguntas.service';
import { CanalService } from '../../_services/canal.service';
import { Funcionalidad } from '../../_models/funcionalidad';
import { AutenticacionService } from '../../_services/autenticacion.service';

@Component( {
  templateUrl: 'banco-preguntas-listado.component.html',
  selector: 'app-preguntas'
} )
export class BancoPreguntasListadoComponent implements OnInit {

  columnas: any[];
  busqueda: string;
  preguntas: Pregunta[];
  carPreguntas: boolean;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private navServicio: NavService,
               private router: Router,
               private canalesService: CanalService,
               private autServicio: AutenticacionService,
               private bancoPreguntasService: BancoPreguntasService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/preguntas' );
    if ( mn ) {
      this.menu = mn;
    }
    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'PREGUNTAS.LBL_CODIGO' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'PREGUNTAS.LBL_PREGUNTA' ), sort: true },
      { field: 'tipoPregunta', header: this.navServicio.buscarMensaje( 'PREGUNTAS.LBL_TIPO' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: true },
    ];


    this.carPreguntas = true;
    this.bancoPreguntasService.listado().subscribe( res => {
      this.carPreguntas = false;
      this.preguntas = res;
    }, e => {
      this.carPreguntas = false;
    } );
  }

  add(): void {
    this.router.navigate( [ 'apl/preguntas/agregar' ] );
  }

  update( pregunta: Pregunta ): void {
    this.router.navigate( [ 'apl/preguntas/actualizar/' + pregunta.idPregunta ] );
  }

  view( pregunta: Pregunta ): void {
    this.router.navigate( [ 'apl/preguntas/detalle/' + pregunta.idPregunta ] );
  }

  setSearch(): void {
    this.navServicio.setSearch( 'bancoPreguntas.component', this.busqueda );
  }

}
